import React, { Component } from 'react'
import { Carousel, Container } from 'react-bootstrap'

export default class Photo2021 extends Component {
    render() {
        return (
            <Container>
                <Carousel id="carouselExampleIndicators" >
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/183312168_3952787371453512_8550481871791642109_n.jpg?_nc_cat=106&ccb=1-3&_nc_sid=730e14&_nc_ohc=L3Dq-lxZtlAAX_hIDJl&_nc_ht=scontent.fkbp1-1.fna&oh=fe6ebd1c1cc946dddf6f7c4619ec900f&oe=60D16272" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/188781330_5621388027934534_7492283884742869747_n.jpg?_nc_cat=107&ccb=1-3&_nc_sid=730e14&_nc_ohc=2IKhW_vk7xQAX9O-CY-&_nc_ht=scontent.fkbp1-1.fna&oh=4ef37b577cc4d248167c2e2fd1f3befd&oe=60D1C296" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/187737718_3930857957004482_6575761356750042339_n.jpg?_nc_cat=110&ccb=1-3&_nc_sid=8bfeb9&_nc_ohc=CCqExdeTcmwAX9S3C6v&_nc_ht=scontent.fkbp1-1.fna&oh=4aceabffa0ee1e2e3ecbbdda0ebbc3fc&oe=60CFDB94" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/187791603_3930857633671181_559248878113672797_n.jpg?_nc_cat=105&ccb=1-3&_nc_sid=8bfeb9&_nc_ohc=KIBnssYUAk8AX-SVE64&_nc_ht=scontent.fkbp1-1.fna&oh=fda314b3b0b401e49065a3b632a84183&oe=60CEA897" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/162461137_5308087965931210_1194553389268179233_n.jpg?_nc_cat=102&ccb=1-3&_nc_sid=0debeb&_nc_ohc=TNhfeJx8S04AX9nq6-i&_nc_ht=scontent.fkbp1-1.fna&oh=a673734971504ed9aa5e7ec44b5607c0&oe=60D171A3" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/162194581_5308090705930936_5102246627451065386_n.jpg?_nc_cat=109&ccb=1-3&_nc_sid=0debeb&_nc_ohc=w5DgUqgCp2cAX9njGFZ&_nc_ht=scontent.fkbp1-1.fna&oh=35bbc5b3a502549fbc035b2b84bfbf3c&oe=60CE302E" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    
                </Carousel> <hr />
            </Container>
        )
    }
}
   
         